/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SkillTranslation } from './';
import {
    SkillTranslationFromJSON,
    SkillTranslationFromJSONTyped,
    SkillTranslationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceTranslation
 */
export interface ExperienceTranslation {
    /**
     * 
     * @type {string}
     * @memberof ExperienceTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceTranslation
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceTranslation
     */
    description?: string;
    /**
     * 
     * @type {Array<SkillTranslation>}
     * @memberof ExperienceTranslation
     */
    skills?: Array<SkillTranslation>;
}

/**
 * Check if a given object implements the ExperienceTranslation interface.
 */
export function instanceOfExperienceTranslation(value: object): value is ExperienceTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ExperienceTranslationFromJSON(json: any): ExperienceTranslation {
    return ExperienceTranslationFromJSONTyped(json, false);
}

export function ExperienceTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(SkillTranslationFromJSON)),
    };
}

export function ExperienceTranslationToJSON(value?: ExperienceTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => SkillTranslationToJSON(v))),
    };
}

